import { all, call, put, takeEvery } from 'redux-saga/effects'

import { historyApi } from '../../api/historyApi'
import {
    HISTORY_GENERATE,
    HISTORY_LOAD_AUDIT,
    HISTORY_LOAD_EXPORTS,
    HISTORY_LOAD_VERSIONS,
    HISTORY_LOAD_VERSION_DATA,
} from '../actions/history'
import { historyActions } from '../slices/history'

function* historyLoadExportsSaga() {
    try {
        yield put(historyActions.setExportsLoading(true))
        yield put(historyActions.setExportsError(null))

        const data = yield call(historyApi.getExportHistory)
        yield put(historyActions.setExports(Array.isArray(data) ? data : []))
    } catch (error) {
        console.error('HISTORY EXPORTS ERROR:', error)
        yield put(historyActions.setExportsError(
            error instanceof Error ? error.message : 'Ошибка загрузки экспортов'
        ))
        yield put(historyActions.setExports([]))
    } finally {
        yield put(historyActions.setExportsLoading(false))
    }
}

function* historyLoadAuditSaga() {
    try {
        yield put(historyActions.setAuditLoading(true))
        yield put(historyActions.setAuditError(null))

        const data = yield call(historyApi.getAuditLog)
        yield put(historyActions.setAudit(Array.isArray(data) ? data : []))
    } catch (error) {
        console.error('HISTORY AUDIT ERROR:', error)
        yield put(historyActions.setAuditError(
            error instanceof Error ? error.message : 'Ошибка загрузки журнала'
        ))
        yield put(historyActions.setAudit([]))
    } finally {
        yield put(historyActions.setAuditLoading(false))
    }
}

function* historyLoadVersionsSaga() {
    try {
        yield put(historyActions.setVersionsLoading(true))
        yield put(historyActions.setVersionsError(null))

        const data = yield call(historyApi.getVersions)

        yield put(historyActions.setVersions({
            versions: Array.isArray(data?.versions) ? data.versions : [],
            maxVersions: typeof data?.max_versions === 'number' ? data.max_versions : 6,
        }))
    } catch (error) {
        console.error('HISTORY VERSIONS ERROR:', error)
        yield put(historyActions.setVersionsError(
            error instanceof Error ? error.message : 'Ошибка загрузки версий'
        ))
        yield put(historyActions.setVersions({ versions: [], maxVersions: 6 }))
    } finally {
        yield put(historyActions.setVersionsLoading(false))
    }
}

function* historyLoadVersionDataSaga(action) {
    const { versionId, table } = action.payload

    try {
        yield put(historyActions.setVersionDataLoading(true))
        yield put(historyActions.setVersionDataError(null))
        yield put(historyActions.setVersionData([]))

        const data = yield call(historyApi.getVersionData, versionId, table)
        yield put(historyActions.setVersionData(Array.isArray(data) ? data : []))
    } catch (error) {
        console.error('HISTORY VERSION DATA ERROR:', error)
        yield put(historyActions.setVersionDataError(
            error instanceof Error ? error.message : 'Ошибка загрузки данных версии'
        ))
    } finally {
        yield put(historyActions.setVersionDataLoading(false))
    }
}

function* historyGenerateSaga() {
    try {
        yield put(historyActions.setGenerating(true))
        yield put(historyActions.setError(null))
        yield put(historyActions.resetNotice())

        yield call(historyApi.generateSchedule)
        yield put(historyActions.setNotice('Расписание успешно сгенерировано'))
    } catch (error) {
        console.error('HISTORY GENERATE ERROR:', error)
        yield put(historyActions.setError(
            error instanceof Error ? error.message : 'Ошибка генерации расписания'
        ))
    } finally {
        yield put(historyActions.setGenerating(false))
    }
}

function* historyLoadExportsWatch() {
    yield takeEvery(HISTORY_LOAD_EXPORTS, historyLoadExportsSaga)
}

function* historyLoadAuditWatch() {
    yield takeEvery(HISTORY_LOAD_AUDIT, historyLoadAuditSaga)
}

function* historyLoadVersionsWatch() {
    yield takeEvery(HISTORY_LOAD_VERSIONS, historyLoadVersionsSaga)
}

function* historyLoadVersionDataWatch() {
    yield takeEvery(HISTORY_LOAD_VERSION_DATA, historyLoadVersionDataSaga)
}

function* historyGenerateWatch() {
    yield takeEvery(HISTORY_GENERATE, historyGenerateSaga)
}

export default function* historyRootSaga() {
    yield all([
        historyLoadExportsWatch(),
        historyLoadAuditWatch(),
        historyLoadVersionsWatch(),
        historyLoadVersionDataWatch(),
        historyGenerateWatch(),
    ])
}
